
import React, { useEffect, useState } from 'react';
import { EditorState, ContentState, convertFromHTML } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import Modal from "react-bootstrap/Modal";
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { convertToHTML } from 'draft-convert';
import axios from 'axios';

const ArticleContentForm = (props) => {

    const [editorState, setEditorState] = useState(
        () => EditorState.createEmpty(),
      );

      const [btn, btnSet] = useState(false);


      const [convertedContent, setConvertedContent] = useState(null);

      useEffect(() => {
        
        let html = convertToHTML(editorState.getCurrentContent());
        setConvertedContent(html);
      }, [editorState]);


   
    const edit=()=>{
        setEditorState(EditorState.createEmpty())
        async function fetchArticle() {
            let content = await fetch(process.env.REACT_APP_API_BEYEGROUP + '/articles/content/' + props.article.id)
            content = await content.json()
            
            let html = EditorState.createWithContent(
                ContentState.createFromBlockArray(
                  convertFromHTML(content?.content)
                )
              )
              setEditorState(html)
        }
        btnSet(false)
        fetchArticle()

      }
      
      const StoreArticle = () =>{
        btnSet(true)
        var data = { 
            categoryId : props.article.category.id,
            content : convertedContent
        }
        axios.put('articles/'+ props.article.id, data).then((response) =>{
            btnSet(false)
            props.showModal()
        }).catch((error) => {
            btnSet(false)
            alert(error.response.data.msg)
        })

      }
    
    return(
        <Modal
            show={props.isModal}
            onHide={props.showModal}
            onEntered={edit}
            size="lg"
            backdrop={"static"}>
            <Modal.Header>
                <Modal.Title>{ "Actualiser le contenue"}</Modal.Title>
            </Modal.Header>
            <form>
                <Modal.Body>
                
                    <Editor
                        editorState={editorState}
                        onEditorStateChange={setEditorState}
                        placeholder="tapez le texte ici..."
                    />
                </Modal.Body>
                <Modal.Footer>
                    <button onClick={props.showModal} type="button" className="btn btn-outline-secondary btn-sm"><i className="bi bi-corner-down-left"></i> Fermer</button>
                    <button onClick={ () => StoreArticle() } disabled={ btn } type="button" className="btn btn-sm btn-outline-primary"><i className="bi bi-check"></i> Sauvegarder</button>
                </Modal.Footer>
            </form>
        </Modal>
    )
}

export default ArticleContentForm